import { render } from "./VideoPreview.vue?vue&type=template&id=3cbc14bb"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=3cbc14bb&lang=css"
script.render = render

export default script